import React,{useState,useEffect} from 'react'
import toast from 'react-hot-toast';
import { FaMapMarkerAlt } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import {message} from "../../messages/Message"

const AcountSettings = () => {

    const [selectedFile, setSelectedFile] = useState(null);
      const [previewSource, setPreviewSource] = useState(null)
       const MAX_FILE_SIZE = 2 * 1024 * 1024; 
  const user=useSelector((state)=>state.profile.user)


   const handlePictureChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.size > MAX_FILE_SIZE) {
                toast.error(message.profilePictureLimitMessage);
                return; 
            }
            setSelectedFile(file);
            previewFile(file);
        }
    };

      const previewFile = (file) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onloadend = () => {
            setPreviewSource(reader.result)
        }
    }
 useEffect(() => {
        if (selectedFile) {
            previewFile(selectedFile)
        }
    }, [selectedFile])


     const handleDeletePicture = () => {
      setPreviewSource(null);
      setSelectedFile("")
            // dispatch(deleteProfilePicture(token));
        };
    

  return (
    <div className="account-setting-page-container">
      <div className="setting-account-first-section">
        <div className="setting-account-left-section">
          <div className="setting-company-logo-wrapper">
            <p>Company Logo</p>
            <img
              src={previewSource || "https://api.dicebear.com/5.x/initials/svg?seed=zenoquad"}
              alt="Company Logo"
              className="setting-company-logo"
            />
            <div className="setting-location">
              <FaMapMarkerAlt className="location-icon" />
              <span>New Delhi, India</span>
            </div>
          </div>
          <div className='setting-buttons'>
             <label className="setting-upload-btn">
                                Upload new
                                <input
                                    type="file"
                                    accept="image/png, image/gif, image/svg,image/jpeg"
                                    style={{ display: 'none' }}
                                     onChange={handlePictureChange}
                                />
                            </label>
            <button className="setting-remove-btn" onClick={handleDeletePicture}>Remove Image</button>
          </div>
        </div>
        <div className="setting-account-right-section">
          <div className="setting-form-group">
            <label>Company Name</label>
            <input type="text" value={user?.business.company_name} readOnly />
          </div>

          <div className="setting-form-group">
            <label>About Company</label>
            <textarea
              rows="4"
              value="This is a platform to spread awareness in the industry of healthcare and medicines……."
              readOnly
            ></textarea>
          </div>
        </div>
      </div>
      <div className='setting-account-second-section'>
        <p className='account-security-heading'>Account Security</p>
        <div className='account-setting-form-group-right'>
          <div className="setting-form-group" style={{ width: "50%" }}>
            <label>Email</label>
            <input type="text"
              style={{ width: "100%" }}
              disabled={true}
              value={user?.email} readOnly />
          </div>
          <div className="setting-form-group" style={{ width: "50%" }}>
            <label>Password</label>
            <input type="password"
              style={{ width: "100%" }}
              disabled={true}
              value={"Abay@22025"} readOnly />
          </div>
        </div>
        <div className="account-setting-toggle-security">
          <div className="setting-security-text">
            <div className="setting-security-title">2 steps verifications</div>
            <div className="setting-security-subtitle">Add an additional layer of security during your login</div>
          </div>
          <label className="setting-switch">
            <input type="checkbox"/>
            <span className="setting-slider"></span>
          </label>
        </div>

      </div>
    </div>
  )
}

export default AcountSettings